import { z } from 'zod';

const MAX_ID_LENGTH = 128;

export const gameIdSchema = z.string().trim().min(1).max(MAX_ID_LENGTH);
export const localeSchema = z.enum(['de', 'en', 'es']);
export const consentCookieSchema = z.enum(['true', 'false']);
export const recentEmojisSchema = z.array(z.string().min(1).max(16)).max(24);

export const authPersistedStateSchema = z
  .object({
    token: z.string().min(1).optional(),
    firebaseIdToken: z.string().min(1).optional(),
    state: z.enum(['initializing', 'idle', 'login', 'register']).optional(),
    authSettled: z.boolean().optional(),
  })
  .passthrough();

export const refreshLockSchema = z.object({
  ownerId: z.string().min(1),
  expiresAt: z.number().finite(),
});

export const localGameSnapshotSchema = z
  .object({
    gameId: z.string().min(1),
    timeCreated: z.union([z.string(), z.number()]),
    boardId: z.number().int().nonnegative(),
    gameType: z.union([z.string(), z.number()]),
    status: z.union([z.string(), z.number()]).optional(),
    eventLog: z.array(z.unknown()).optional(),
    lastRemovedCards: z.array(z.unknown()),
    state: z.record(z.string(), z.unknown()),
    statePrev: z.record(z.string(), z.unknown()).optional(),
    statePrevPrev: z.record(z.string(), z.unknown()).optional(),
    visibility: z.string().optional(),
    allowSpectators: z.boolean().optional(),
    chatVisibility: z.string().optional(),
  })
  .passthrough();

export const legacyLocalGameSnapshotSchema = z
  .object({
    gameId: z.string().min(1),
    gameType: z.union([z.string(), z.number()]),
    game: z.record(z.string(), z.unknown()),
    lastRemovedCards: z.array(z.unknown()),
  })
  .passthrough();
